import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-3 w-100" }
const _hoisted_2 = {
  key: 0,
  class: "primary w-full pa-2 d-flex justify-center flex-column"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_HereAddress = _resolveComponent("HereAddress")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          class: "d-flex justify-center align-center pb-3",
          col: "6",
          sm: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "mx-2",
              color: _ctx.travelExpense.vehiculeType === 'CAR' ? 'primary' : 'grey',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVehiculeType('CAR'))),
              size: "large",
              icon: "$oss-car"
            }, null, 8, ["color"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          class: "d-flex justify-center align-center pb-3",
          cols: "6",
          sm: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: _normalizeClass('mx-2 '),
              color: 
                        _ctx.travelExpense.vehiculeType === 'TWO_REAR_WHEELS_GT_50' ? 'primary' : 'grey'
                    ,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setVehiculeType('TWO_REAR_WHEELS_GT_50'))),
              size: "large",
              icon: "$oss-moto"
            }, null, 8, ["color"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          class: "d-flex justify-center align-center",
          cols: "6",
          sm: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: _normalizeClass('mx-2'),
              color: 
                        _ctx.travelExpense.vehiculeType === 'TWO_REAR_WHEELS_LTE_50' ? 'primary' : 'grey'
                    ,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setVehiculeType('TWO_REAR_WHEELS_LTE_50'))),
              size: "large",
              icon: "$oss-motorcycle"
            }, null, 8, ["color"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          class: "d-flex justify-center align-center",
          cols: "6",
          sm: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mr-1' : 'mx-2'),
              color: _ctx.travelExpense.vehiculeType === 'BICYCLE' ? 'primary' : 'grey',
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setVehiculeType('BICYCLE'))),
              size: "large",
              icon: "$oss-bicycle"
            }, null, 8, ["class", "color"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          class: "d-flex justify-center align-center",
          col: "6",
          sm: "3"
        }),
        _createVNode(_component_v_col, {
          class: "d-flex justify-center align-center",
          cols: "6",
          sm: "3"
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode(" +50cm² ")
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, {
          class: "d-flex justify-center align-center",
          cols: "6",
          sm: "3"
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode(" -50cm² ")
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, {
          class: "d-flex justify-center align-center",
          cols: "6",
          sm: "3"
        })
      ]),
      _: 1
    }),
    (_ctx.travelExpense.vehiculeType === 'CAR')
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": "",
          class: "text-center d-flex align-center"
        }, {
          default: _withCtx(() => [
            (_ctx.$vuetify.display.mobile)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  class: "text-center align-center mx-auto mr-2 pt-2",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select_filled, {
                      modelValue: _ctx.travelExpense.power,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.travelExpense.power) = $event)),
                      items: _ctx.powerCar,
                      "hide-details": "",
                      readonly: !_ctx.commonEnableModification,
                      label: "Choissisez la puissance",
                      density: "compact",
                      "item-title": "text"
                    }, null, 8, ["modelValue", "items", "readonly"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "12",
                  class: "text-center align-center pl-10"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mr-1' : 'mx-2'),
                      variant: _ctx.travelExpense.power >= 4 ? 'outlined' : 'flat',
                      color: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setPower(1))),
                      rounded: "",
                      elevation: "0",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$vuetify.display.mobile ? "- de " : "Moins de ") + " 4 CV ", 1)
                      ]),
                      _: 1
                    }, 8, ["class", "variant"]),
                    _createVNode(_component_v_btn, {
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mr-1' : 'mx-2'),
                      variant: _ctx.travelExpense.power !== 4 ? 'outlined' : 'flat',
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setPower(4))),
                      color: "primary",
                      rounded: "",
                      elevation: "0",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode(" 4 CV ")
                      ])),
                      _: 1
                    }, 8, ["class", "variant"]),
                    _createVNode(_component_v_btn, {
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mr-1' : 'mx-2'),
                      variant: _ctx.travelExpense.power !== 5 ? 'outlined' : 'flat',
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setPower(5))),
                      color: "primary",
                      rounded: "",
                      elevation: "0",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode(" 5 CV ")
                      ])),
                      _: 1
                    }, 8, ["class", "variant"]),
                    _createVNode(_component_v_btn, {
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mr-1' : 'mx-2'),
                      variant: _ctx.travelExpense.power !== 6 ? 'outlined' : 'flat',
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setPower(6))),
                      color: "primary",
                      rounded: "",
                      elevation: "0",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode(" 6 CV ")
                      ])),
                      _: 1
                    }, 8, ["class", "variant"]),
                    _createVNode(_component_v_btn, {
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mt-1' : 'mx-2'),
                      variant: _ctx.travelExpense.power < 7 ? 'outlined' : 'flat',
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setPower(7))),
                      color: "primary",
                      rounded: "",
                      elevation: "0",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$vuetify.display.mobile ? "+ de " : "PLus de ") + " 6 CV ", 1)
                      ]),
                      _: 1
                    }, 8, ["class", "variant"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }))
      : (_ctx.travelExpense.vehiculeType === 'TWO_REAR_WHEELS_GT_50')
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "text-center d-flex align-center",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              (_ctx.$vuetify.display.mobile)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    class: "text-center align-center mx-auto mr-2 pt-2",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.travelExpense.power,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.travelExpense.power) = $event)),
                        items: _ctx.powerTwoWheels,
                        "hide-details": "",
                        readonly: !_ctx.commonEnableModification,
                        label: "Choissisez la puissance",
                        density: "compact",
                        "item-title": "text"
                      }, null, 8, ["modelValue", "items", "readonly"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    cols: "12",
                    class: "text-center align-center pl-10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mr-1' : 'mx-2'),
                        variant: _ctx.travelExpense.power >= 3 ? 'outlined' : 'flat',
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setPower(1))),
                        color: "primary",
                        rounded: "",
                        elevation: "0",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$vuetify.display.mobile ? "- de " : "Moins de ") + " 3 CV ", 1)
                        ]),
                        _: 1
                      }, 8, ["class", "variant"]),
                      _createVNode(_component_v_btn, {
                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mr-1' : 'mx-2'),
                        variant: 
                        _ctx.travelExpense.power < 2 || _ctx.travelExpense.power > 5 ? 'outlined' : 'flat'
                    ,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setPower(4))),
                        color: "primary",
                        rounded: "",
                        elevation: "0",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createTextVNode(" entre 3 et 5 CV ")
                        ])),
                        _: 1
                      }, 8, ["class", "variant"]),
                      _createVNode(_component_v_btn, {
                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mt-1' : 'mx-2'),
                        variant: _ctx.travelExpense.power < 6 ? 'outlined' : 'flat',
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setPower(6))),
                        color: "primary",
                        rounded: "",
                        elevation: "0",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$vuetify.display.mobile ? "+ de " : "Plus de ") + " 5 CV ", 1)
                        ]),
                        _: 1
                      }, 8, ["class", "variant"])
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (['TWO_REAR_WHEELS_GT_50', 'CAR'].includes(_ctx.travelExpense.vehiculeType))
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 2,
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_switch, {
                  class: _normalizeClass('mx-2'),
                  modelValue: _ctx.travelExpense.electricalType,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.travelExpense.electricalType) = $event)),
                  label: "Véhicule électrique"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_divider, { class: "my-2" }),
    _createVNode(_component_v_card, { elevation: "0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, { class: "px-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              style: {"position":"relative"}
            }, {
              default: _withCtx(() => [
                (_ctx.isModifiedByUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[26] || (_cache[26] = [
                      _createTextVNode(" La distance a été éditée par l'utilisateur, il n'est donc pas possible de renseigner les adresses. "),
                      _createElementVNode("div", { class: "pt-2 font-weight-medium" }, " Repasser la distance à 0 pour pouvoir renseigner les adresses. ", -1)
                    ])))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_HereAddress, {
                            readonly: _ctx.expenseStatus === 'VALIDATED',
                            wordingAddress: _ctx.originAddress,
                            onCoordinates: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hereAddressDeparture($event))),
                            label: "Adresse de départ",
                            "data-cy": "ExpenseReportAddress-depart"
                          }, null, 8, ["readonly", "wordingAddress"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_HereAddress, {
                            readonly: _ctx.expenseStatus === 'VALIDATED',
                            wordingAddress: _ctx.destinationAddress,
                            onCoordinates: _cache[16] || (_cache[16] = ($event: any) => (_ctx.hereAddressArrival($event))),
                            label: "Adresse d'arrivée",
                            "data-cy": "ExpenseReportAddress-arrivee"
                          }, null, 8, ["readonly", "wordingAddress"])
                        ]),
                        _: 1
                      })
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex align-center flex-grow-1 flex-shrink-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_divider)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "d-flex justify-center flex-grow-0 flex-shrink-1 font-weight-bold px-2" }, {
          default: _withCtx(() => _cache[27] || (_cache[27] = [
            _createTextVNode(" OU ")
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "d-flex align-center flex-grow-1 flex-shrink-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_divider)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "d-flex mb-2 align-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "flex-grow-1 flex-shrink-0 align-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_oss_text_field_filled, {
              outlined: "",
              cols: "4",
              class: _normalizeClass({
                        'mr-1 mt-1': true,
                        'mx-2': !_ctx.$vuetify.display.mobile,
                    }),
              label: "Distance",
              modelValue: _ctx.travelExpenseDistance,
              "onUpdate:modelValue": [
                _cache[17] || (_cache[17] = ($event: any) => ((_ctx.travelExpenseDistance) = $event)),
                _cache[18] || (_cache[18] = ($event: any) => (_ctx.onDistanceIsEdited()))
              ],
              "hide-details": "",
              "content-class": "mt-2",
              suffix: 'km',
              disabled: !_ctx.commonEnableModification,
              "data-cy": "expenseReport-travelExpense-distance"
            }, null, 8, ["class", "modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          class: "flex-grow-0 flex-shrink-1 align-center",
          style: {"display":"contents"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_switch, {
              class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'mr-1 mt-1 mx-2' : ' mt-3 mx-2'),
              modelValue: _ctx.travelExpense.switchRoundTrip,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.travelExpense.switchRoundTrip) = $event)),
              label: "Aller-Retour",
              size: "small"
            }, null, 8, ["class", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "pt-4 px-0 pb-0 d-flex justify-center"
    }, {
      default: _withCtx(() => [
        (_ctx.showTravelExpenseCalculation)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "auto",
              class: "px-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode(" Année barème ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.travelExpense.year), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showTravelExpenseCalculation)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 1,
              cols: "auto",
              class: "px-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                        _createTextVNode(" Appliquable aux frais ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.travelExpense.year-1), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showTravelExpenseCalculation)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 2,
              cols: "auto",
              class: "px-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode(" Distance * coéfficient ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => [
                        (!_ctx.travelExpense.switchRoundTrip)
                          ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "(" + _toDisplayString(_ctx.travelExpenseDistance) + " km * " + _toDisplayString(_ctx.coef) + ")", 1))
                          : (_openBlock(), _createElementBlock("h4", _hoisted_4, "(" + _toDisplayString(_ctx.travelExpenseDistance * 2) + " km * " + _toDisplayString(_ctx.coef) + ")", 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showTravelExpenseCalculation)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 3,
              cols: "auto",
              class: "px-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode(" Montant fixe ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", null, "+ " + _toDisplayString(_ctx.fixAmount), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_col, {
          cols: "auto",
          class: "px-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode(" Total : ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.travelExpenseAmount, undefined)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}